module.exports = __webpack_public_path__ + "img/dgjg2250_2.55741b08.svg";